import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
} from 'react'

import { Page } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

import { State } from '../../CanaryPageBuilder/types'
import { useThemePreview } from './useThemePreview'

export interface ThemePreviewContext {
  state: State
  pages: Page[]
  dispatch: Dispatch<SetStateAction<any>>
}

const ThemePreviewContext = createContext<ThemePreviewContext>(undefined)

export const ThemePreviewProvider = ({ children }) => {
  const { data: network } = useNetwork()

  const pages = useMemo(
    () => network?.systemSpaces || [],
    [network?.systemSpaces],
  )

  const { state, dispatch } = useThemePreview()

  return (
    <ThemePreviewContext.Provider
      value={{
        state,
        dispatch,
        pages,
      }}
    >
      {children}
    </ThemePreviewContext.Provider>
  )
}

export const useThemePreviewContext = () => {
  const context = useContext(ThemePreviewContext)
  if (context === undefined) {
    throw new Error(
      'useThemePreview must be used within a ThemePreviewProvider',
    )
  }
  return context
}
